import { Grid } from "@mui/material";
import React from "react";
import SubCategoriesHeader from "./home/header";
import SubCategoriesTabel from "./home/table";

const SubCategories = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SubCategoriesHeader />
      </Grid>
      <Grid item xs={12}>
        <SubCategoriesTabel />
      </Grid>
    </Grid>
  );
};

export default SubCategories;
